import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PALoans from './PALoans';
import PAOpps from './PAOpps';
import Spinner from "react-bootstrap/Spinner";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const LoansPreApproved = ( { settings } ) => {
    const [ pageType, setPageType ] = useState( 'opps' );
    const [loaded, setLoaded] = useState(false);

    useEffect( () => {
        if ( settings?.preapprovals?.pageType === 'loans' ) {
            setPageType( 'loans' );
        }
        console.log('PA Page Type: ', settings?.preapprovals?.pageType);
        setLoaded(true);
    }, [ settings ] );
    
    return (
        <>
            { 
                loaded ? (
                    pageType === 'loans' ? <PALoans /> : <PAOpps />
                ): (
                    <Row className='py-3'>
                        <Col className='text-center'>
                            <Spinner animation="border" variant='primary' role="status" />
                        </Col>
                    </Row>
                )
            }
        </>
    )
}

const mapProps = ( state ) => ( {
    settings: state.user.meta.settings
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LoansPreApproved );